/*------------------------------------------------------------------
Document Setup
------------------------------------------------------------------*/

Promise.all([import('accordions')]).then(_ref => {
  let [moduleAccordion] = _ref;
  const Accordion = moduleAccordion.default;
  Watcher.observe('.js-default-tabbed-content', blocks => {
    blocks.forEach(block => {
      const tabs = block.querySelectorAll('.js-default-tabbed-content__link');
      const items = block.querySelectorAll('.js-default-tabbed-content__item');
      const Controller = new Accordion(block);
      for (let i = 0; i < items.length; i++) {
        // Save the item
        const item = items[i];
        Controller.add(item, {
          active: i == 0,
          trigger: tabs[i],
          target: items[i]
        });
      }

      // Activate the tab
      tabs.forEach((tab, i) => {
        if (i == 0) tab.classList.add('active');
        tab.addEventListener('click', e => {
          tabs.forEach(t => t.classList.toggle('active', t === tab));
        });
      });
    });
  });
});